import script from "./AnalysisCriteria.vue?vue&type=script&setup=true&lang=ts"
export * from "./AnalysisCriteria.vue?vue&type=script&setup=true&lang=ts"

import "./AnalysisCriteria.vue?vue&type=style&index=0&id=9654ef5c&scoped=true&lang=scss"
import "./AnalysisCriteria.vue?vue&type=style&index=1&id=9654ef5c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9654ef5c"]])

export default __exports__